import { ReactNode, createContext, useContext } from 'react'

type ProvideFileScopeContextProps = {
  children: ReactNode
  publicFileScope: boolean
  workflowId: string
}

export const FileScope = createContext({
  publicFileScope: false,
  workflowId: '',
})

export const ProvideFileScopeContext = ({
  children,
  publicFileScope,
  workflowId,
}: ProvideFileScopeContextProps) => (
  <FileScope.Provider value={{ publicFileScope, workflowId }}>
    {children}
  </FileScope.Provider>
)

export const useFileScope = () => useContext(FileScope)
